import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";

const AOSRefresh = () => {
  const location = useLocation();

  useEffect(() => {
    AOS.refresh();
  }, [location]);

  return null;
};

export default AOSRefresh;